import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/logo.jpeg";
import "./Header.css";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login", { replace: true });
  };

  return (
    <header className="navbar">
      {/* LEFT: LOGO + COLLEGE NAME */}
      <div className="nav-left">
        <img
          src={logo}
          alt="College Logo"
          className="college-logo"
        />
        <div className="college-text">
          <h1>BLUE MOON DEGREE COLLEGE</h1>
          <p className="college-sub">
            Affiliated to S.K. University | College Code: 0193
          </p>
          <p className="college-address">
            Near Gangamma Mori, N.H.205, Kutagulla – 515 541, <br />
            Kadiri, Sri Satya Sai Dist, A.P
          </p>
        </div>
      </div>

      {/* HAMBURGER */}
      <div
        className="hamburger"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        ☰
      </div>

      {/* MENU */}
      <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
        <Link to="/">Home</Link>
        <Link to="/about">About Us</Link>
        <Link to="/college-details">Academics</Link>
        <Link to="/faculty">Faculty</Link>
        <Link to="/gallery">Gallery</Link>
        <Link to="/contact">Contact</Link>

        {token ? (
          <>
            <Link to="/admin" className="admin-btn">Admin</Link>
            <button onClick={logout} className="logout-btn">
              Logout
            </button>
          </>
        ) : (
          <Link to="/login" className="login-btn">
            Login
          </Link>
        )}
      </nav>
    </header>
  );
}

export default Header;
















